export default __webpack_public_path__ + "img/223e4196b911c6653a084070d28ef1bd.svg";